import React from "react";
import { ImgV2 } from "../../ImgV2";
export const TradingViewSection = ({ evaluation, marks, logoUrl, textColor }) => (React.createElement("div", { className: "tradingView-section-root" },
    React.createElement("p", { className: "caption2-bold", style: { color: textColor } }, evaluation),
    React.createElement("p", { className: "tradingView-section-root__marks", style: { color: textColor } }, marks),
    React.createElement(ImgV2, { src: logoUrl, alt: logoUrl })));
